export function isBoolean(value: any): boolean {
  return typeof value === 'boolean';
}
